import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import { pinia, useAuthStore, useNotificationStore } from './stores'
import { setupApiInterceptors } from './services'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#6366f1',
          'primary-darken-1': '#4f46e5',
          secondary: '#64748b',
          accent: '#8b5cf6',
          error: '#ef4444',
          warning: '#f59e0b',
          info: '#3b82f6',
          success: '#10b981',
          background: '#f8fafc',
          surface: '#ffffff',
          'surface-variant': '#f1f5f9',
          'on-surface': '#1e293b',
          'on-background': '#1e293b',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#818cf8',
          'primary-darken-1': '#6366f1',
          secondary: '#94a3b8',
          accent: '#a78bfa',
          error: '#f87171',
          warning: '#fbbf24',
          info: '#60a5fa',
          success: '#34d399',
          background: '#0f172a',
          surface: '#1e293b',
          'surface-variant': '#334155',
          'on-surface': '#e2e8f0',
          'on-background': '#e2e8f0',
        },
      },
    },
  },
  defaults: {
    VCard: {
      elevation: 0,
      rounded: 'lg',
      border: true,
    },
    VBtn: {
      rounded: 'lg',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
    },
  },
})

const app = createApp(App)

// Install plugins
app.use(pinia)
app.use(router)
app.use(vuetify)

// Setup API interceptors with stores (must be after pinia is installed)
const authStore = useAuthStore()
const notificationStore = useNotificationStore()
setupApiInterceptors(authStore, notificationStore, router)

// Initialize auth state
authStore.initializeAuth()

app.mount('#app')
